/*
 * File: FormattedInput.tsx
 * Author: Austin Robinson
 * Date Created: 10/26/2023
 * Copyright (c) DrivingDoc 2023
 */
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { useController, useFormContext } from 'react-hook-form';
import { PatternFormat, PatternFormatProps } from 'react-number-format';

interface PropTypes extends PatternFormatProps<Omit<TextFieldProps, 'variant'>> {
  name: string;
  label: string;
}

export default function FormattedInput({ name, label, ...props }: PropTypes) {
  const { control } = useFormContext();
  const { field, fieldState } = useController({ control, name });
  return (
    <Box>
      {label && (
        <Typography
          component={InputLabel}
          htmlFor={name}
          variant="subtitle1"
          color="text.primary"
          fontWeight={700}
          disabled={props.disabled}
        >
          {label}
        </Typography>
      )}
      <PatternFormat
        id={name}
        fullWidth
        customInput={TextField}
        InputLabelProps={{ shrink: true }}
        error={!!fieldState.error}
        helperText={fieldState.error?.message}
        getInputRef={field.ref}
        value={field.value}
        onBlur={field.onBlur}
        onValueChange={(values) => {
          field.onChange(values.value);
        }}
        {...props}
      />
    </Box>
  );
}
